export function formatRemainTime (time, reg) {
  const date =
    typeof time === 'string'
      ? new Date(time)
      : typeof time === 'number'
        ? new Date(time)
        : time;
  const remainTime = parseInt((+date - (+new Date())) / 1000, 10);
  if (remainTime < 0) return '已结束';
  const map = {};
  map.d = parseInt(remainTime / 60 / 60 / 24, 10);
  map.dd = (map.d < 10 ? '0' : '') + map.d;
  map.H = parseInt(remainTime / 60 / 60 % 24, 10);
  map.HH = (map.H < 10 ? '0' : '') + map.H;
  map.m = parseInt(remainTime / 60 % 60, 10);
  map.mm = (map.m < 10 ? '0' : '') + map.m;
  map.s = parseInt(remainTime % 60, 10);
  map.ss = (map.s < 10 ? '0' : '') + map.s;

  return reg.replace(/\bdd|d|HH|H|mm|m|ss|s\b/g, $1 => map[$1]);
}
